const features = [
  {
    icon: 'ri-magic-line',
    title: 'AI一键生成',
    description: '输入文案或关键词，AI自动生成完整视频内容，包括画面、配音和字幕，从灵感到成品只需几分钟。',
  },
  {
    icon: 'ri-scissors-cut-line',
    title: '智能剪辑',
    description: 'AI自动分析素材，智能识别精彩片段，匹配最佳转场与节奏，让你告别繁琐的手动剪辑流程。',
  },
  {
    icon: 'ri-voiceprint-line',
    title: 'AI智能配音',
    description: '支持50+语言和200+声音风格，AI配音自然流畅，语气情感丰富，几乎无法分辨是AI生成。',
  },
  {
    icon: 'ri-subtract-line',
    title: '自动字幕生成',
    description: '语音识别准确率高达98%，支持多语言字幕翻译，丰富的字幕样式模板，一键导出多种格式。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多平台适配',
    description: '一键生成横版、竖版、方形多尺寸版本，AI自动调整画面构图，完美适配抖音、B站、YouTube等平台。',
  },
  {
    icon: 'ri-cloud-line',
    title: '云端协作',
    description: '项目云端存储，支持团队多人协作编辑，版本历史管理，随时随地继续你的创作。',
  },
];

export default function FeaturesSection() {
  return (
    <section className="w-full py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-14">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
              全方位的AI视频创作能力
            </h2>
            <p className="text-foreground-600 text-base max-w-2xl mx-auto">
              萝卜视频整合了多项AI核心技术，覆盖视频创作的全流程，让创作变得前所未有的简单高效
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {features.map((feature) => (
              <div
                key={feature.title}
                className="p-6 rounded-lg bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer group"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-5 group-hover:bg-primary-500 group-hover:text-white transition-colors">
                  <i className={`${feature.icon} text-xl`}></i>
                </div>
                <h3 className="text-lg font-heading font-semibold text-foreground-900 mb-3">
                  {feature.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}